
var sprite = require("/opt/build/repo/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 8 17.97\" id=\"arrow-left\" ><defs/><title>arrow-left</title><g id=\"arrow-left_Layer_2\" data-name=\"Layer 2\"><g id=\"arrow-left_Icons\"><path class=\"cls-1\" d=\"M0 8.98l6.61 8.99L8 16.9 2.38 8.98 8 1.03 6.61 0 0 8.98z\" id=\"arrow-left_arrow-left\"/></g></g></symbol>";
module.exports = sprite.add(image, "arrow-left");


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/arrow-left.svg
// module id = 644
// module chunks = 1474